exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-body[data-v-0e9a4251] span{font-size:12pt!important}", ""]);

// exports
